export const formatPrice = (price: number, isCents?: boolean) =>
  (isCents ? price / 100 : price).toFixed(2);
